"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var projectActions = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var projectMemberActions = require("@caddigital/sok-reducers/lib/actions/project/members");
var userSettingsActions = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var MemberList_1 = require("components/MemberList");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var UserSettingsModal_1 = require("components/modals/UserSettingsModal");
var CreateEditCategory_1 = require("../Modal/CreateEditCategory");
var EditGroup_1 = require("../Modal/EditGroup");
var InviteModal_1 = require("./InviteModal");
var utils_1 = require("./utils");
require("./styles.scss");
var mapStateToProps = function (state) {
    return {
        currentUser: state.auth.current.user,
        step3: state.project.wizard.step3,
        projectId: state.project.wizard.step1.id
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    addMemberToggleModal: function () {
        return dispatch(projectActions.UsergroupInvite.inviteToggleModal());
    },
    deleteGroup: function (name, groupId) { return function () {
        return dispatch(projectActions.deleteEditUserGroupRequest('DELETE', name, groupId));
    }; },
    editGroup: function (name, id) { return function () {
        return dispatch(projectActions.deleteEdit('EDIT', 'GROUP', name, id));
    }; },
    deleteCategory: function (name, categoryId) { return function () {
        return dispatch(projectActions.deleteEditCategoryRequest('DELETE', name, categoryId));
    }; },
    editCategory: function (name, id) { return function () {
        return dispatch(projectActions.deleteEdit('EDIT', 'CATEGORY', name, id));
    }; },
    deleteUser: function (x, groupId) { return function () {
        return dispatch(projectActions.removeUserFromGroup(x.id, groupId));
    }; },
    openUserSettingsModal: function (user, projectId) {
        return dispatch(userSettingsActions.openUserSettingsModal(user, 'ADMIN', [
            projectActions.UsergroupList.fetchRequest('PROJECT', projectId)
        ]));
    },
    getProjectUserGroups: function (id) {
        return dispatch(projectActions.UsergroupList.fetchRequest('PROJECT', id));
    },
    setSearch: function (_a) {
        var value = _a.target.value;
        return dispatch(projectActions.UsergroupList.searchGroups(value));
    },
    deleteCategoriesGroupsUsers: function (categoryIds, groupIds, selectedUsers) {
        dispatch(projectActions.deleteEditCategoryRequest('DELETE', window.name, categoryIds));
        dispatch(projectActions.deleteEditUserGroupRequest('DELETE', window.name, groupIds));
        selectedUsers.forEach(function (x) {
            return dispatch(projectActions.removeUserFromGroup(x.userId, x.groupId));
        });
    },
    removeProjectUsers: function (projectId, users) {
        return dispatch(projectMemberActions.deleteGroupsUsersRequest(projectId, users, 'WIZARD'));
    },
    setFilter: function (filter, value) {
        return dispatch(projectActions.UsergroupList.setColumnFilter(filter, value));
    },
    setGroupsSelected: function (items, selected) {
        return dispatch(projectActions.UsergroupList.setGroupsSelected(items, selected));
    },
    setUsersSelected: function (items, selected) { return dispatch(projectActions.UsergroupList.setUsersSelected(items, selected)); },
    collapseUserRow: function (id, isCollapsed) {
        return dispatch(projectActions.UsergroupList.collapseUserRow(id, isCollapsed));
    },
    setSortingSelector: function (sortBy) {
        return dispatch(projectActions.UsergroupList.setSortingSelector(sortBy));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('warningModal', 'setWarningModal', null), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.getProjectUserGroups(this.props.projectId);
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.step3.groups !== nextProps.step3.groups) {
            return true;
        }
        if (this.props.warningModal !== nextProps.warningModal ||
            this.props.step3.searchString !== nextProps.step3.searchString ||
            this.props.step3.selectedUsers !== nextProps.step3.selectedUsers ||
            this.props.step3.selectedGroups !== nextProps.step3.selectedGroups ||
            this.props.step3.isCollapsed !== nextProps.step3.isCollapsed) {
            return true;
        }
        if (this.props.step3.invite === nextProps.step3.invite ||
            this.props.step3.invite !== nextProps.step3.invite) {
            return false;
        }
        return false;
    }
}), recompose_1.pure);
var removeCategoriesAndGroups = function (props) {
    var modalTitle = (0, translation_1.getLocalization)('admin/projectsTab/editProject/templates/removeConfirm');
    var modalMessage = (0, translation_1.getLocalization)('admin/projectsTab/editProject/users/removeSelectedUsers');
    var selectedUserUuids = props.step3.selectedUsers.map(function (_a) {
        var user = _a.user;
        return user.uuid;
    });
    var selectedUserAssignments = (0, utils_1.getSelectedUserAssignments)(props.step3.groups, selectedUserUuids);
    var modalProps = {
        title: modalTitle,
        content: [modalMessage],
        action: function () {
            props.setUsersSelected(props.step3.selectedUsers, false);
            props.setGroupsSelected(props.step3.selectedGroups, false);
            props.removeProjectUsers(props.projectId, selectedUserAssignments);
        }
    };
    props.setWarningModal(modalProps);
};
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'project-wizard-sok-usergroups-content' },
    React.createElement("div", { className: 'card-box' },
        React.createElement("h2", null,
            React.createElement(sok_ui_1.Icon, { className: 'icofont-labour' }),
            ' ',
            (0, translation_1.getLocalization)('admin/projectsTab/editProject/users/list/users')),
        React.createElement("div", { className: 'card-box-content' },
            React.createElement("div", { className: 'buttons' },
                React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { key: 'invite-icon', className: 'fa-plus-circle' }), size: 'large', onClick: props.addMemberToggleModal, color: 'base-green', className: 'text-left', text: (0, translation_1.getLocalization)('admin/projectsTab/editProject/users/invite'), disabled: props.step3.status !== 'FETCHED' }),
                React.createElement(sok_ui_1.Button, { disabled: props.step3.selectedGroups.length === 0 &&
                        props.step3.selectedUsers.length === 0, icon: React.createElement(sok_ui_1.Icon, { key: 'remove-icon', className: 'fa-trash-alt' }), size: 'large', color: 'red', className: 'text-left', text: (0, translation_1.getLocalization)('admin/projectsTab/editProject/users/remove'), onClick: function () { return removeCategoriesAndGroups(props); } })),
            React.createElement(sok_ui_1.TextInput, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-search' }), className: 'white', placeholder: (0, translation_1.getLocalization)('admin/projectsTab/editProject/users/search'), value: props.step3.searchString, onChange: props.setSearch }),
            React.createElement(MemberList_1.MemberList, { translationKeys: {
                    notFound: {
                        title: 'userfront/project/teamMembers/placeHolderTitle',
                        description: 'userfront/project/teamMembers/placeHolderDescription',
                        help: 'userfront/project/teamMembers/placeHolderHelp'
                    }
                }, groups: props.step3.groups, searchString: props.step3.searchString, isCollapsed: props.step3.isCollapsed, isDeleteColumnHidden: true, isEditColumnHidden: true, isValidityColumnHidden: true, selectedUsers: props.step3.selectedUsers, selectedGroups: props.step3.selectedGroups, status: props.step3.status, sortingAndPagination: props.step3.sortingAndPagination, permission: props.currentUser.fold(0, function (u) {
                    return u.level === 'SuperAdminUserGroup' ? acl.SUPER_ADMIN_GRANT : 0;
                }), filters: props.step3.filters, fetch: function () { return props.getProjectUserGroups(props.projectId); }, setUsersSelected: props.setUsersSelected, setGroupsSelected: props.setGroupsSelected, collapseUserRow: props.collapseUserRow, setWarningModal: function () { return false; }, openUserSettingsModal: function (user) {
                    return props.openUserSettingsModal(user, props.projectId);
                }, setSortingSelector: props.setSortingSelector, setFilter: props.setFilter }),
            React.createElement(InviteModal_1.default, null),
            React.createElement(CreateEditCategory_1.default, null),
            React.createElement(EditGroup_1.default, null),
            React.createElement(UserSettingsModal_1.default, null),
            React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.warningModal !== null, close: function () { return props.setWarningModal(null); }, header: props.warningModal
                    ? props.warningModal.title
                    : (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, null),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                        React.createElement("div", { className: 'text' }, ((props.warningModal && props.warningModal.content) ||
                            []).map(function (x) { return (React.createElement("p", null, x)); })))), footer: React.createElement(React.Fragment, null,
                    React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                            if (props.warningModal) {
                                props.warningModal.action();
                                props.setWarningModal(null);
                            }
                        } }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setWarningModal(null); } })) }))))); });
